/* eslint-disable */
import React from "react";
import { Group, Box, Text, Button } from "@mantine/core";
import CardAdmin from "./components/cards";
import TableOrg from "./components/tableOrg";
import ChartAnalytics from "./components/chartCard";
import { useGetUser } from "api/users/getUser";
// import TableOrg from "../system/components/tableOrg";
// import ChartAnalytics from "../system/components/chartCard";
// import CardAdmin from "../system/components/cards";

export default function SuperAdminDashboard() {
  const { data: user } = useGetUser();
  return (
    <Box
      sx={{
        minHeight: "100vh",
        // padding: "20px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          backgroundColor: "white",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
          padding: "10px",
        }}
      >
        <Group spacing="sm">
          <Box
            sx={{
              backgroundColor: "#fff",
              borderRadius: "8px",
              padding: "8px 12px",
            }}
          >
            <Text weight={700}>
              {`${user?.firstName?.trim().charAt(0).toUpperCase() ?? ""} ${
                user?.lastName
                  ? user.lastName.trim().charAt(0).toUpperCase() + " "
                  : ""
              }`}
            </Text>
          </Box>
          <Box>
            <Text weight={700} size="lg" color="black">
              {`${user?.firstName} ${user?.lastName}`}
            </Text>
            <Text size="sm" color="black" opacity={0.8}>
              System-wide dashboard and management
            </Text>
          </Box>
        </Group>
        <Group spacing="sm">
          <Box
            sx={{
              backgroundColor: "#5c4bff",
              borderRadius: "8px",
              padding: "8px 12px",
            }}
          >
            <Text weight={700} color="black">
              {`${user?.firstName?.trim().charAt(0).toUpperCase() ?? ""} ${
                user?.lastName
                  ? user.lastName.trim().charAt(0).toUpperCase() + " "
                  : ""
              }`}
            </Text>
          </Box>
          <Box>
            <Text weight={700} color="black">
              {`${user?.firstName} ${user?.lastName}`}
            </Text>
            <Text size="sm" color="black" opacity={0.8}>
              {user?.email}
            </Text>
          </Box>
        </Group>
      </Box>

      <CardAdmin />

      <TableOrg />

      <ChartAnalytics />
    </Box>
  );
}
